module.exports = __webpack_public_path__ + "media/images/front/top/mitsubishi_tanabe_live-c434ca799e3f15b3fdf9b2da69368cb0.png";